import { canv } from "@/canv/global.js";
import { getTarget } from "@/canv/utils.js";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

const shapesList = [
    "rect",
    "roundedRect",
    "circle",
    "triangle",
    "rombus",
    "bubble",
    "RSkewRect",
    "arrowRight",
    "arrowLeft",
] as const;

type ShapeType = (typeof shapesList)[number];
type OptionsList = widgetOption<string>[];

export class WmShape extends wmBase {
    constructor(options: OptionsList) {
        super();
        this.options = options;
    }

    build() {
        const uniqValues = Array.from(new Set(this.options.map((opt) => opt.value)));
        const viewSrc =
            uniqValues.length === 1
                ? canv.shapeStorage.getShape(uniqValues[0]).getView()
                : this.multiShape;

        return `
            <div class="wm_shape">
                ${viewSrc}
            </div>
            <div class="wm_dividor"></div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_shape");
        item?.removeEventListener("click", this.showSubMenu, false);
        item?.addEventListener("click", this.showSubMenu, false);
    }

    showSubMenu = (e) => {
        const subm = document.querySelector(".wm_shape_submenu");
        if (subm) {
            subm.outerHTML = "";
            return;
        }
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        canv.widgetMenu.subMenuBoss = "wm_shape";
        const submenu = document.createElement("div");
        submenu.classList.add("widgetSubMenu");
        submenu.classList.add("wm_shape_submenu");
        submenu.style.opacity = "0";
        document.body.prepend(submenu);

        for (let i = 0; i < this.shapes.length; i++) {
            submenu.innerHTML += this.submenuTemplate(
                this.shapes[i] as (typeof shapesList)[number],
            );
        }

        submenu.innerHTML += this.getMoreButton();

        const items = document.querySelectorAll(".wm_shape_submenu_item");
        for (let i = 0; i < items.length; i++) {
            items[i]?.removeEventListener("click", this.itemClick as EventListener, false);
            items[i]?.addEventListener("click", this.itemClick as EventListener, false);
        }

        const more = document.querySelector(".wm_shape_submenu_more");
        more?.removeEventListener("click", this.showMoreShapes.bind(this), false);
        more?.addEventListener("click", this.showMoreShapes.bind(this), false);

        setTimeout(canv.widgetMenu.TryLocateMenu.bind(canv.widgetMenu), 50);
    };

    itemClick = (e: MouseEvent): void => {
        const item = getTarget(e, "wm_shape_submenu_item") as HTMLElement | null;
        if (!item) return;

        const mode = item.getAttribute("mode");
        if (!mode) return;

        this.applyValue(this.options, mode);

        const menuItem = document.querySelector(".wm_shape");
        if (menuItem) {
            menuItem.innerHTML = canv.shapeStorage.getShape(mode).getView();
        }
    };

    showMoreShapes() {
        const subMenu = document.querySelector(".wm_shape_submenu") as HTMLElement | undefined;
        if (!subMenu) return;

        subMenu.classList.add("scrollable");
        subMenu.innerHTML = "";

        const shapes = canv.shapeStorage.getAllShapes();
        for (const shape of shapes) {
            subMenu.innerHTML += this.submenuTemplate(shape as (typeof shapesList)[number]);
        }

        const items = document.querySelectorAll(".wm_shape_submenu_item");
        for (const el of Array.from(items)) {
            el.removeEventListener("click", this.itemClick as EventListener, false);
            el.addEventListener("click", this.itemClick as EventListener, false);
        }
    }

    // Temlates
    submenuTemplate(mode: ShapeType) {
        return `
            <div class="wm_shape_submenu_item" mode=${mode}>
                ${canv.shapeStorage.getShape(mode).getView()}
            </div>
        `;
    }

    getMoreButton() {
        return `
            <div class="wm_shape_submenu_more"><p>+</p></div>
        `;
    }

    name = "wm_shape";
    options: OptionsList = [];
    shapes = shapesList;
    multiShape = `
        <svg width="23" height="23" viewBox="0 0 116 117" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.5" y="3.5" width="63" height="63" rx="31.5" fill="white" stroke="black" stroke-width="7"/>
            <rect x="49.5" y="50.5" width="63" height="63" fill="white" stroke="black" stroke-width="7"/>
        </svg>
    `;
}
